module.exports = __webpack_public_path__ + "files/Mentee_list_example.5cba5f62.csv";